import script from "./WCMessageStickyAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCMessageStickyAlert.vue?vue&type=script&setup=true&lang=ts"

import "./WCMessageStickyAlert.vue?vue&type=style&index=0&id=70dde5ba&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70dde5ba"]])

export default __exports__